/** @jsx jsx */

import { IconButton, Tooltip } from '@zapier/design-system';
import { jsx } from '@emotion/core';

type Props = {
  ariaLabel?: string;
  onDismiss: () => void;
};

const Dismiss = ({ onDismiss, ariaLabel = 'Close' }: Props) => (
  // For accessibility, we wrap the IconButton in a Tooltip to clarify the purpose of the button.
  <Tooltip content={ariaLabel}>
    <IconButton
      aria-label={ariaLabel}
      name="formX"
      onPress={onDismiss}
      size="small"
    />
  </Tooltip>
);

export default Dismiss;
